<template>
  <div class="icebreakers-container">

    <!-- 主要内容区域 -->
    <div class="main-layout">
      <!-- 左侧用户选择 -->
      <UserListSidebar :selected-user="selectedUser" title="用户选择" @select-user="selectUser" />

      <!-- 右侧内容区域 -->
      <div class="content-area">
        <!-- 顶部导航栏 -->
        <div class="header">
          <div class="header-left">
            <h1 class="title">Icebreakers</h1>
          </div>
          <div class="header-center">
            <button class="nav-btn" :class="{ active: currentTab === 'create' }" @click="switchTab('create')">
              创建
            </button>
            <button class="nav-btn" :class="{ active: currentTab === 'launch' }" @click="switchTab('launch')">
              发送
            </button>
            <button class="nav-btn" :class="{ active: currentTab === 'manage' }" @click="switchTab('manage')">
              管理
            </button>
          </div>
        </div>
        <!-- 创建新icebreaker -->
        <CreateIcebreaker v-if="currentTab === 'create'" ref="createIcebreakerDom" :selected-user="selectedUser" />

        <!-- 设置发送 -->
        <LaunchIcebreaker v-if="currentTab === 'launch'" :selected-user="selectedUser" />

        <!-- 管理icebreaker -->
        <ManageIcebreaker v-if="currentTab === 'manage'" :selected-user="selectedUser" />
      </div>
    </div>
  </div>
</template>

<script>
import CreateIcebreaker from './components/CreateIcebreaker.vue'
import LaunchIcebreaker from './components/LaunchIcebreaker.vue'
import ManageIcebreaker from './components/ManageIcebreaker.vue'
import UserListSidebar from '@/components/UserListSidebar.vue';

export default {
  name: 'Icebreakers',
  components: {
    CreateIcebreaker,
    LaunchIcebreaker,
    ManageIcebreaker,
    UserListSidebar
  },
  data() {
    return {
      currentTab: 'launch',
      // 用户选择相关
      selectedUserId: null,
      selectedUser: null
    }
  },

  mounted() {
    // 移除 initData 调用，让 UserListSidebar 组件自动获取数据
  },

  computed: {
    // 获取用户列表，与 UserListSidebar 组件使用相同的数据源
    userList() {
      return this.$store.state.accountList.accountList || [];
    }
  },

  // 监听用户列表变化，确保默认选中第一个用户
  watch: {
    userList: {
      handler(newAccountList) {
        // 如果用户列表有数据但没有选中用户，则默认选中第一个
        if (newAccountList && newAccountList.length > 0 && !this.selectedUser) {
          console.log('检测到用户列表变化，默认选中第一个用户')
          const userList = newAccountList.map((item, index) => {
            return {
              ...item,
              onLine: true
            }
          })
          this.selectUser(userList[0])
        }
      },
      immediate: true
    }
  },

  methods: {
    switchTab(tab) {
      this.currentTab = tab
      // 移除重复调用，因为 CreateIcebreaker 组件的 watch 监听器会自动处理数据获取
      // if (tab === 'create') {
      //   this.$nextTick(() => {
      //     console.log(this.$refs, 'this.$refs')
      //     if (this.$refs.createIcebreakerDom) {
      //       this.$refs.createIcebreakerDom.getIcebreakersLimitsFun()
      //     }
      //   })
      // }
    },

    // 移除 initData 方法，改为使用 UserListSidebar 组件自动获取数据

    selectUser(user) {
      console.log('选中用户:', user)
      // 使用正确的用户ID字段 - 用户对象中有 id 字段，没有 platformUserId
      this.selectedUserId = user.id
      this.selectedUser = user
      localStorage.setItem('activeUser', JSON.stringify(user))
      console.log('用户选择完成 - selectedUserId:', this.selectedUserId, 'selectedUser:', this.selectedUser)

      // 移除重复调用，因为 CreateIcebreaker 组件的 watch 监听器会自动处理数据获取
      // this.$nextTick(() => {
      //   // 重新获取创建页面的限制数据
      //   if (this.$refs.createIcebreakerDom) {
      //     this.$refs.createIcebreakerDom.getIcebreakersLimitsFun()
      //   }
      // })
    }
  }
}
</script>

<style scoped lang="scss">
.icebreakers-container {
  height: calc(100vh - 56px);
  background: linear-gradient(135deg, #3730a3 0%, #581c87 100%);
  display: flex;
  flex-direction: column;
}

/* 头部样式 */
.header {
  background: rgba(255, 255, 255, 0.95);
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-left .title {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(135deg, #3730a3 0%, #581c87 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
}

.header-center {
  display: flex;
  gap: 8px;
}

.nav-btn {
  padding: 8px 16px;
  border: 2px solid transparent;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.nav-btn:hover {
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.nav-btn.active {
  background: linear-gradient(135deg, #3730a3 0%, #581c87 100%);
  color: white;
  border-color: transparent;
  box-shadow: 0 4px 15px rgba(55, 48, 163, 0.6);
}

/* 主要内容布局 */
.main-layout {
  flex: 1;
  display: flex;
  overflow: hidden;
}

/* 左侧用户选择区域 */
.user-sidebar {
  width: 320px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.95) 100%);
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  flex-direction: column;
  box-shadow:
    4px 0 25px rgba(0, 0, 0, 0.08),
    inset 1px 0 0 rgba(255, 255, 255, 0.5);
  position: relative;
  overflow: hidden;
}

.user-sidebar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.8) 50%, transparent 100%);
}

.user-sidebar-header {
  padding: 24px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  background: linear-gradient(135deg, rgba(248, 250, 252, 0.95) 0%, rgba(241, 245, 249, 0.9) 100%);
  position: relative;
}

.user-sidebar-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 20px;
  right: 20px;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(55, 48, 163, 0.1) 50%, transparent 100%);
}

.user-sidebar-title {
  margin: 0 0 20px 0;
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  position: relative;
  padding-left: 16px;
}

.user-sidebar-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 20px;
  background: linear-gradient(135deg, #3730a3 0%, #581c87 100%);
  border-radius: 2px;
}



.user-list-container {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.3) 0%, rgba(248, 250, 252, 0.2) 100%);
  position: relative;
}

.user-list-container::-webkit-scrollbar {
  width: 6px;
}

.user-list-container::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}

.user-list-container::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #3730a3 0%, #581c87 100%);
  border-radius: 3px;
}

.user-list-container::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #581c87 0%, #3730a3 100%);
}

.user-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  margin-bottom: 10px;
  border-radius: 16px;
  cursor: pointer;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 250, 252, 0.8) 100%);
  border: 2px solid transparent;
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  position: relative;
  overflow: hidden;
}

.user-item:hover {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.9) 100%);
  box-shadow:
    0 8px 20px rgba(0, 0, 0, 0.1),
    0 4px 8px rgba(0, 0, 0, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  border-color: rgba(55, 48, 163, 0.3);
}

.user-item.active {
  background: linear-gradient(135deg, rgba(55, 48, 163, 0.1) 0%, rgba(88, 28, 135, 0.08) 100%);
  border-color: #3730a3;
  box-shadow:
    0 8px 25px rgba(55, 48, 163, 0.3),
    0 4px 12px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  position: relative;
}

.user-item.active::after {
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(135deg, #3730a3 0%, #581c87 100%);
  border-radius: 0 16px 16px 0;
}

.user-avatar {
  position: relative;
  flex-shrink: 0;
}

.avatar-img {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid rgba(255, 255, 255, 0.9);
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  position: relative;
}

.user-item:hover .avatar-img {
  border-color: rgba(55, 48, 163, 0.3);
  box-shadow:
    0 6px 16px rgba(0, 0, 0, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.user-item.active .avatar-img {
  border-color: #3730a3;
  box-shadow:
    0 6px 20px rgba(55, 48, 163, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.online-indicator {
  position: absolute;
  bottom: 3px;
  right: 3px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #d1d5db;
  border: 3px solid white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.online-indicator.online {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  box-shadow:
    0 2px 8px rgba(16, 185, 129, 0.4),
    0 0 0 2px rgba(16, 185, 129, 0.2);
}

.user-info {
  flex: 1;
  min-width: 0;
  position: relative;
}

.user-name {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
}

.user-item:hover .user-name {
  color: #3730a3;
}

.user-item.active .user-name {
  color: #3730a3;
  font-weight: 700;
}

.user-id {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
  position: relative;
}

.user-item:hover .user-id {
  color: #581c87;
}

.user-item.active .user-id {
  color: #581c87;
  font-weight: 600;
}

.user-status {
  flex-shrink: 0;
  position: relative;
}

.vip-icon {
  color: #fbbf24;
  font-size: 18px;
  text-shadow: 0 1px 2px rgba(251, 191, 36, 0.3);
}

.user-item:hover .vip-icon {
  color: #f59e0b;
}

.loading-more,
.no-users {
  text-align: center;
  padding: 24px 20px;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.5) 0%, rgba(248, 250, 252, 0.3) 100%);
  border-radius: 12px;
  margin: 8px 0;
  border: 1px solid rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

.loading-more::before,
.no-users::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

.loading-more i {
  margin-right: 8px;
  color: #3730a3;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* 右侧内容区域 */
.content-area {
  flex: 1;
  padding: 24px 32px;
  overflow-y: auto;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%);
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
}

.content-area::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.2) 50%, transparent 100%);
}





/* 响应式设计 */
@media (max-width: 768px) {
  .header {
    padding: 16px;
    flex-direction: column;
    gap: 16px;
  }

  .header-center {
    order: 2;
  }

  .main-layout {
    flex-direction: column;
  }

  .user-sidebar {
    width: 100%;
    height: 300px;
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }

  .content-area {
    padding: 16px;
  }

  .user-sidebar-header {
    padding: 20px 16px;
  }

  .user-sidebar-title {
    font-size: 18px;
    margin-bottom: 16px;
  }

  .user-list-container {
    padding: 8px;
  }

  .user-item {
    padding: 12px 14px;
    margin-bottom: 8px;
    border-radius: 12px;
  }

  .avatar-img {
    width: 44px;
    height: 44px;
  }

  .user-name {
    font-size: 14px;
    margin-bottom: 4px;
  }

  .user-id {
    font-size: 12px;
  }

  .online-indicator {
    width: 12px;
    height: 12px;
    bottom: 2px;
    right: 2px;
  }

  .vip-icon {
    font-size: 16px;
  }
}
</style>
